import React, { useState, useEffect } from "react";
import {Table} from '../../../data-table/Table';
import { CSVLink } from "react-csv";
import { Redirect } from "react-router-dom";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DownloadIcon from '@mui/icons-material/Download';
import ErrorIcon from '@mui/icons-material/Error';
import Tooltip from '@mui/material/Tooltip';
import "../../components/custom_material_ui_like.css"
import Button from '@mui/material/Button';
import { GPAP_Button_Orange } from "../../../../gpap-lib/Button_Collection";


const SummaryInserted = (props) => {

    const { title, tableContents,tableFailContents,filename } = props.location;
    const { nextPage, nextPageLabel,tooltip } = props.location;
    const { previousPage, previousPageLabel,previousTooltip } = props.location;

    const [next, setNext] = useState(false);
    const [back, setBack] = useState(false);

    const goBack = () => {
        setBack(true);
    };

    const goNext = () => {
        setNext(true);
    }; 

    /*Go to next view*/
    if (next) {
        return <Redirect to={{pathname:nextPage, contents:tableContents}}/>;
    }
    
    /*Go to previous view*/
    if (back) {
        return  <Redirect to={{pathname:previousPage}}/>;
    }

    return(
        <div className={"mainContent"}>
            <Typography variant={"h5"} align={"center"}> {title} </Typography>

            {/* Report Error */}
            { tableFailContents.length > 1 ?
                <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-start" }}>
                    <Grid container direction="row" alignItems="center">
                        <Grid item> 
                            <Chip 
                                color="error" 
                                icon={<ErrorIcon />} 
                                sx={{m:1}}
                                label={"Errors on submision!"} 
                            />
                        </Grid>
                        <Grid item> 
                            <Tooltip title={previousTooltip}>
                                <Button
                                    color="error"
                                    variant="contained"
                                    startIcon={<ArrowBackIcon />}
                                    onClick={goBack}
                                >
                                    {previousPageLabel}
                                </Button>  
                            </Tooltip>                           
                        </Grid>
                    </Grid>      
                </Grid>
                :
                    null
            }

            { /* Show Success Insertion */ }
            { tableContents.length > 1 ?
                    <> 
                        
                        <Typography variant={"h6"} align={"center"}>Summary of your Submission</Typography>
                         
                        <Grid container rowSpacing={1}>
                            
                            <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-start" }}>
                                <CSVLink 
                                    className="custom_mui_button_ligth" 
                                    data={tableContents} 
                                    filename={filename}
                                >
                                    <Grid container direction="row" alignItems="center">
                                        <Grid item> <DownloadIcon /> </Grid>
                                        <Grid item> DOWNLOAD AS CSV </Grid>
                                    </Grid>        
                                </CSVLink>     
                            </Grid>
                            
                            <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                                { nextPage !== "" ?
                                    <Tooltip title={tooltip}>
                                        <GPAP_Button_Orange
                                            startIcon={<ArrowForwardIcon />}
                                            onClick={goNext}
                                        >
                                            {nextPageLabel}
                                        </GPAP_Button_Orange> 
                                    </Tooltip>
                                 :
                                    null
                                }  
                            </Grid> 
                        </Grid>
                        
                        <Table tableContents = {tableContents} />
                    </>
                :
                    null
            }
            
            {/* Table of submission fails */}
            { tableFailContents.length > 1 ?
                    <>
                        <Typography 
                            variant={"h6"} 
                            align={"center"} 
                            color={"error"}
                        >
                            Summary of submission fails
                        </Typography>

                        <Grid container rowSpacing={1}> 
                            <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-start" }}>
                                <CSVLink 
                                    className="custom_mui_button_ligth" 
                                    data={tableFailContents} 
                                    filename={"failed_" + filename}
                                >
                                    <Grid container direction="row" alignItems="center">
                                        <Grid item> <DownloadIcon color='error'/> </Grid>
                                        <Grid item> DOWNLOAD FAILED REPORT AS CSV </Grid>
                                    </Grid>        
                                </CSVLink>     
                            </Grid>
                        </Grid>


                        <Table tableContents = {tableFailContents} />
                    </>    
                :
                    null
            }
        </div>
    );
}

export default SummaryInserted;
